import NodeViewConstructorArgs from '../constructor/NodeViewConstructorArgs';
import AbstractNodeView from './AbstractNodeView';
import ViewActions from '../constants/ViewActions';
import * as d3 from 'd3';
import start from '../assets/start.svg';
import WorkFlowView from '../view/WorkFlowView';
import View from '../view/View';
import { Syntax } from '@trlogic/ui-pack';
import { NodeType } from '../../../../domain/collection/rule/FlowDomains';

class StartNodeView extends AbstractNodeView {
  public constructor(args: NodeViewConstructorArgs) {
    super(args);
  }

  public initialize(): void {
    this.render();
  }

  public render(): void {
    let node: any;

    if (this.shadow) {
      node = d3.select((this.workFlowView as WorkFlowView).getParent()).append('svg');
    } else {
      node = d3
        .select((this.workFlowView as WorkFlowView).getNode())
        .select('#workflow-container-group')
        .append('g');
    }

    const nodeEnter = node
      .attr('id', this.el.substring(1, this.el.length))
      .attr('type', 'Start')
      .style('position', 'absolute')
      .style('pointer-events', 'auto')
      .style('width', '50px')
      .style('height', '50px');

    nodeEnter
      .append('rect')
      .attr('width', 50)
      .attr('height', 50)
      .attr('rx', 3)
      .style('stroke', 'green')
      .attr('stroke-width', 1)
      .style('fill', 'white')
      .style('stroke-dasharray', '0');

    nodeEnter
      .append('svg:image')
      .attr('xlink:href', start)
      .attr('width', 20)
      .attr('height', 20)
      .attr('x', 50 / 2 - 10)
      .attr('y', 50 / 2 - 10);

    nodeEnter
      .append('text')
      .attr('x', 50 / 2 + 40)
      .attr('y', 50 / 2 - 2)
      .attr('dy', '.35em')
      .style('fill', '#4F4F4F')
      .text(this.getModel<any>().value.name);
  }

  public socketHighlight(type?: NodeType): void {}

  public socketUnHighlight(): void {}

  protected preSwap(target: View<Syntax>): boolean {
    return false;
  }

  public setModel(model: Syntax) {}
}

export default StartNodeView;
